// extracted by mini-css-extract-plugin
module.exports = {"notice":"fXDYm","body":"_3WiFP","bg1":"XVSjG","bg2":"_2BB2G","textCon":"_1x5pN","text2":"_2m6-6","anniversary":"E8vf6","text1":"_3_8Zb","text3":"_2REIt","close":"_27PYF"};